import React, { useRef, useState } from 'react';
import { TextArea2 } from '@fitinsur/components/Dialog';
import Icon from 'components/Icon';
import * as S from './styles';
import { Button } from '@fitinsur/components';

export default function ModalInfo({
    title,
    note,
    setNote,
    setModalShow,
    disabled,
    handleUpdateNotes,
}) {
    const myRef = useRef();

    return (
        <S.Dialog>
            <S.DialogBody ref={myRef}>
                <S.DialogHeader>
                    <S.DialogText>
                        {title || 'Additional Information'}
                    </S.DialogText>
                    <S.IconsContainer>
                        <Icon
                            name='close'
                            className="icon-close"
                            onClick={() => {
                                setModalShow(false);
                            }}
                        />
                    </S.IconsContainer>
                </S.DialogHeader>

                <S.DialogContent>
                    <TextArea2
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        disabled={disabled}
                    />
                    {!disabled && (
                        <Button
                            style={{ margin: 0, marginLeft: '16px', width: '100%' }}
                            primary
                            onClick={() => handleUpdateNotes()}
                        >
                            Salvar
                        </Button>
                    )}
                </S.DialogContent>
            </S.DialogBody>
        </S.Dialog>
    );
}